export default __webpack_public_path__ + "static/media/denien_permission.5f77e357.svg";